<div class="app-integration-preset-form">
  <!-- Create form -->
  <form [formGroup]="form">
    <!-- Name -->
    <div class="form-group">
      <label for="name">Preset Name</label>
      <input
        type="text"
        id="name"
        formControlName="name"
        class="lum-input form-control"
      />
      <mat-error *ngIf="nameControl && nameControl.invalid">
        <small>
          {{ nameControl | validateField }}
        </small>
      </mat-error>
    </div>
  </form>

  <div class="font-bold mt-4 mb-4">Add Shipping Options</div>
  <lum-app-integration-shipping-options-form
    [appIntegrationAccountId]="appIntegrationAccountId"
    [currentShippingPreset]="selectedPreset"
    [actionTitle]="selectedPreset ? 'Update' : 'Save'"
    [loading]="submittingForm"
    (cancelEvent)="onCancel()"
    (submitEvent)="onSubmit($event)"
  ></lum-app-integration-shipping-options-form>
</div>
